import { css } from 'styled-components';

export default css`
  .delivery-method {
    width: 29%;
    height: 90px;
    margin-top: 10px;
  }

  .edd-details {
    margin-top: 5px;
    width: 77%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 56%;
      height: 19px;
      margin-top: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 26px;
    }
  }

  .edd-details-two {
    margin-top: 2px;
    width: 54%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;
